export default __webpack_public_path__ + "static/media/BAM-Logo-Schwarz-Auf-Weiss.d78dd97d.jpg";